'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Toolbar = require('./Toolbar');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Toolbar).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/Toolbar/index.js
// module id = 156
// module chunks = 0